import get from 'lodash.get';

const getValue = (batch, elementId, attribute, computeFallbackValue = null) => {
  const currentValue = get(batch, `${elementId}.${attribute}`);

  if (computeFallbackValue && !currentValue) {
    return computeFallbackValue({ elementId, attribute });
  }

  return currentValue;
};

const getBatchValues = (batch, { elementIds, attributes, computeFallbackValue = null }) =>
  attributes.map((attribute) => {
    if (elementIds.length > 1) {
      return elementIds
        .map((elementId) => getValue(batch, elementId, attribute, computeFallbackValue))
        .filter((value) => value !== undefined);
    }

    return getValue(batch, elementIds[0], attribute, computeFallbackValue);
  });

export default getBatchValues;
